<span
  class="lty-badge danger"
  *ngIf="!topText && !bottomText && displayBadge"
  >{{ emptyText }}</span
>

<div class="stacked-text" *ngIf="topText || bottomText">
  <span class="main-text">{{ topText }}</span>
  <span class="secondary-text">{{ bottomText }}</span>
</div>
